import * as React from 'react';

import { ControllerProps } from 'src/router';
import { InvoiceList } from 'src/app/accounting/shared/invoices/list/invoice-list';
import { InvoiceListDataService } from 'src/app/accounting/shared/invoices/list/invoice-list.data';
import { resolve } from 'inversify-react';
import { ToastNotifications } from 'src/core/ui/toast';
import { DataLocalService } from 'src/core/services/data-local.service';
import { ObjectUtils } from 'src/core/utils/object';

interface Props extends ComponentViewProps<PaymentSummary> {
}

interface State {
	invoices: DataSet<InvoiceSummary>;
}

export class PaymentInvoicesList extends React.Component<Props, State> {
	@resolve
	private toast: ToastNotifications;

	private dataService: InvoiceListDataService;

	constructor(props: Readonly<Props>) {
		super(props);

		this.state = {
			invoices: new DataLocalService<InvoiceSummary>([])
		};
	}

	componentDidMount(): void {
		const { setBusy } = this.props;

		setBusy(true);
		this.loadData()
			.catch((error) => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				this.props.setBusy(false)
			});
	}

	private async loadData(): Promise<void> {
		const { model } = this.props;
		this.dataService = InvoiceListDataService.make();

		const items = await this.dataService.getPaymentInvoices(model.id);
		this.setState({
			invoices: new DataLocalService<InvoiceSummary>(items)
		});
	}

	render(): React.ReactNode {
		const { setBusy } = this.props;
		const { invoices } = this.state;

		return (
			<InvoiceList
				model={invoices}
				setBusy={setBusy}
			/>
		);
	}
}




// WEBPACK FOOTER //
// ./src/app/accounting/shared/payments/parts/payment-invoices-list.tsx